import { useEffect } from "react";

function setMetaTag(property, content, attr = "property") {
  let meta = document.querySelector(`meta[${attr}="${property}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute(attr, property);
    document.head.appendChild(meta);
  }
  meta.content = content;
}

export default function SEOHead({ title, description, canonical, ogType }) {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.rel = "canonical";
        document.head.appendChild(link);
      }
      link.href = canonical;

      setMetaTag("og:url", canonical);
    }

    setMetaTag("og:title", title);
    setMetaTag("og:description", description);
    setMetaTag("og:type", ogType || "website");
  }, [title, description, canonical, ogType]);

  return null;
}
